// extracted by mini-css-extract-plugin
module.exports =  {"root":"lehBDqI_zWVhoUonJv2w"};